import { render, staticRenderFns } from "./ActionQuitarPrioridadAsignacion.vue?vue&type=template&id=7f008d86&lang=pug"
import script from "./ActionQuitarPrioridadAsignacion.vue?vue&type=script&lang=js"
export * from "./ActionQuitarPrioridadAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports